import { METRICS } from 'types/metrics';

export interface IWeightAnswer {
	unit?: METRICS;
	value?: string;
}

export interface IHeightAnswer {
	unit?: string;
	value?: UnitValueAnswer[];
}

export interface UnitValueAnswer {
	unit: METRICS;
	value?: string;
}

export interface IDateAnswer {
	value?: DateValueAnswer;
}

export interface DateValueAnswer {
	value?: string;
}

export const isCorrectUnitValue = (unit: METRICS, value?: string): boolean => {
	if (!value) return false;
	switch (unit) {
		case METRICS.FT:
			return +value > 3 && +value < 8;

		case METRICS.IN:
			return +value > -1 && +value < 12;

		case METRICS.CM:
			return +value > 121 && +value < 243;

		case METRICS.LBS:
			return +value > 65 && +value < 330;

		case METRICS.KG:
			return +value > 29 && +value < 151;

		default:
			return false;
	}
};

export const isCorrectDateValue = (value?: string): boolean => {
	if (value) {
		const currentDate = new Date();
		const inputDate = new Date(value);
		const tomorrow = new Date(currentDate);
		tomorrow.setDate(tomorrow.getDate() + 1);
		if (inputDate < tomorrow) {
			return false;
		} else {
			return true;
		}
	} else {
		return false;
	}
};

export const isUnitValueAboveRange = (unit: METRICS, value?: string): boolean => {
	if (!value) return false;
	switch (unit) {
		case METRICS.FT:
			return +value > 6;

		case METRICS.IN:
			return +value > 11;

		case METRICS.CM:
			return +value > 299;

		case METRICS.LBS:
			return +value > 500;

		case METRICS.KG:
			return +value > 299;

		default:
			return false;
	}
};

export const convertLbsToKg = (value?: number | null): number | null => {
	if (!value) return null;
	return Math.round(value * 0.453592);
};

export const convertKgToLbs = (value?: number | null): number | null => {
	if (!value) return null;
	return Math.round(value * 2.20462);
};

export const convertFtToCm = (value: { ft: number; in: number }): number | null => {
	if (!value) return null;
	return Math.round(value.ft * 30.48 + value.in * 2.54);
};

export const getValueForSurvey = (...args: UnitValueAnswer[]): string => JSON.stringify(args);

export const getValueDateForSurvey = (...args: DateValueAnswer[]): string => JSON.stringify(args);

export const parseFromAnswer = (
	answer?: UnitValueAnswer[],
): Record<METRICS, string | undefined> | object | undefined => {
	if (answer == null) return undefined;

	const result = answer.reduce<Record<METRICS, string | undefined> | object>((acc, object) => {
		const { unit, value } = object;
		return { ...acc, [unit]: value };
	}, {});

	return result;
};

export const parseFromDateAnswer = (
	answer?: DateValueAnswer,
): string | undefined | object | undefined => {
	if (answer == null) return undefined;
	return answer;
};
